import * as L from 'leaflet';
import 'leaflet-gpx';

type Waypoint = {
  lat: number;
  lng: number;
};

export class SingleBaladeEtape {
  private mapElement: HTMLElement | null;;
  private waypoints: Waypoint[] = [];
  private gpxUrl: string | undefined;
  private mapInstance: L.Map;
  private locations?: any[];
  private geolocateBtn?: HTMLButtonElement | null;

  constructor() {
    this.mapElement = document.querySelector<HTMLElement>('[data-map-single-balade-etape]');

    if (!this.mapElement) {
      return;
    }

    this.gpxUrl = this.mapElement.dataset.gpx;
    this.waypoints = JSON.parse(this.mapElement.dataset.waypoints || '[]');
    this.geolocateBtn = document.querySelector('[data-geolocate]') as HTMLButtonElement | null;
    this.locations = JSON.parse(this.mapElement.dataset.locations || '[]');
    if (this.gpxUrl && this.waypoints.length > 0 && this.geolocateBtn) {
      this.initMap();
      if (this.geolocateBtn) {
        this.setupGeolocation();
      }
    }
  }

  private initMap(): void {
    this.mapInstance = L.map(this.mapElement);

    L.tileLayer('https://{s}.tile.openstreetmap.org/{z}/{x}/{y}.png', {
      attribution: '&copy; <a href="https://www.openstreetmap.org/copyright">OpenStreetMap</a> contributors'
    }).addTo(this.mapInstance);

    const startIconUrl = this.mapElement?.dataset.startIcon;
    const endIconUrl = this.mapElement?.dataset.endIcon;

    if (this.gpxUrl) {
      const gpxOptions: any = {
        async: true,
        polyline_options: { color: '#0036FF' },
        markers: {
          startIcon: startIconUrl,
          endIcon: endIconUrl,
          shadowUrl: ''
        },
        marker_options: {
          iconSize: [80, 46],
          iconAnchor: [46, 70]
        }
      };
      new (L as any).GPX(this.gpxUrl, gpxOptions).on('loaded', (e: any) => { e.target.getBounds() }).addTo(this.mapInstance);
    }
    // Markers Adresses
    if (this.locations && this.locations.length > 0) {
      const markerBounds = L.latLngBounds([]);
      this.locations!.forEach(loc => {
        const customIcon = L.icon({
          iconUrl: loc.icon_url,
          iconSize: [32, 32],
          iconAnchor: [16, 32],
          popupAnchor: [0, -35]
        });

        const marker = L.marker([loc.lat, loc.lng], { icon: customIcon })
          .addTo(this.mapInstance!)
          .bindPopup(loc.popup);
        // On ajoute chaque point à nos limites globales
        markerBounds.extend(marker.getLatLng());
      });
    }

    // Markers Étapes
    if (this.waypoints.length > 0) {
      const markers: L.Marker[] = [];
      const etapeStr = this.mapElement?.dataset.etape;
      let targetIndex = -1;

      if (etapeStr) {
        const etapeNum = parseInt(etapeStr, 10);
        if (!isNaN(etapeNum) && etapeNum >= 1 && etapeNum <= this.waypoints.length) {
          targetIndex = etapeNum - 1;
        }
      }

      this.waypoints.forEach((point, index) => {
        console.log(index)
        console.log(point)
        if (typeof point.lat === 'number' && typeof point.lng === 'number') {
          const iconClassName = index === targetIndex ? 'waypoint current' : 'waypoint';

          const numberedIcon = L.divIcon({
            className: iconClassName,
            iconSize: [46, 46],
            iconAnchor: [23, 23],
            html: `${index + 1}`
          });
          const marker = L.marker([point.lat, point.lng], { icon: numberedIcon });
          markers.push(marker);
          marker.addTo(this.mapInstance);
        }
      });

      if (this.waypoints.length > 0) {
        const initialZoomLevel = 17;

        if (etapeStr) {
          const etapeNum = parseInt(etapeStr, 10);

          if (!isNaN(etapeNum) && etapeNum >= 1 && etapeNum <= this.waypoints.length) {

            const targetIndex = etapeNum - 1;
            const targetWaypoint = this.waypoints[targetIndex];
            this.mapInstance.setView(
              [targetWaypoint.lat, targetWaypoint.lng],
              initialZoomLevel
            );
            // Décalage 25% + haut
            const mapHeight = this.mapInstance.getSize().y;
            const verticalOffset = mapHeight * 0.25;
            this.mapInstance.panBy([0, +verticalOffset]);
            return;
          }
        }
        const firstWaypoint = this.waypoints[0];
        this.mapInstance.setView(
          [firstWaypoint.lat, firstWaypoint.lng],
          initialZoomLevel
        );
      }

    }

    setTimeout(() => {
      this.mapInstance.invalidateSize(true);
    }, 100);
  }

  // Géolocalisation
  private setupGeolocation(): void {
    if (!this.geolocateBtn || !this.mapInstance) {
      return;
    }
    const geolocateIconUrl = this.geolocateBtn.dataset.geolocateIcon;


    this.geolocateBtn.addEventListener('click', () => {

      this.mapInstance?.locate({ setView: true, maxZoom: 16 });

    });

    this.mapInstance.on('locationfound', (e: L.LocationEvent) => {
      const markerOptions: L.MarkerOptions = {};

      if (geolocateIconUrl) {
        const customIcon = L.icon({
          iconUrl: geolocateIconUrl,
          iconSize: [32, 32],
          iconAnchor: [16, 32],
        });
        markerOptions.icon = customIcon;
      }
      L.marker(e.latlng, markerOptions).addTo(this.mapInstance!);
      // Décalage 20% + haut
      this.mapInstance.setView(e.latlng, 16);
      const mapHeight = this.mapInstance.getSize().y;
      const verticalOffset = mapHeight * 0.20;
      this.mapInstance.panBy([0, verticalOffset]);
    });
  }
}

export const singleBaladeEtape = new SingleBaladeEtape();